import { status } from "../_constants/commonIVY";
import { signInConstant } from "../_constants/signIn.constant";

let initialState = {}

export function signIn(state = initialState, action) {
    switch (action.type) {
        case signInConstant.CREATE_SIGNIN_REQUEST:
            return {
                ...state,
                signIn_status: status.IN_PROGRESS,
                signIn_data: null,
            }
        case signInConstant.CREATE_SIGNIN_SUCCESS:
            return {
                ...state,
                signIn_status: status.SUCCESS,
                signIn_data: action.data,
            }
        case signInConstant.CREATE_SIGNIN_FAILURE:
            return {
                ...state,
                signIn_status: status.FAILURE,
                signIn_data: action.data,
            };
        // case signInConstant.GET_SIGNIN_REQUEST:
        //     return {
        //         ...state,
        //         signIn_status: status.IN_PROGRESS,
        //         signIn_data: null
        //     }
        // case signInConstant.SUCCESS:
        //     return {
        //         ...state,
        //         signIn_status: status.SUCCESS,
        //         signIn_data: action.data,
        //     }
        // case signInConstant.FAILURE:
        //     return {
        //         ...state,
        //         signIn_status: status.FAILURE,
        //         signIn_data: null
        //     }
        default:
            return state;
    }
}